import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { alertActions, commonActions, certboxActions, inboxActions, sentActions } from '../../../../store/actions'
import PdfViewer from '../../../../module/pdf/PdfViewer'
import Alert from '../../../../module/alert/Alert'

const CertificateSentList = (props) => {
  const [checkedContacts, setCheckedContacts] = useState(new Set())
  const checkedContactsRef = useRef(checkedContacts)

  const [isColBtnShow, setIsColBtnShow] = useState({})

  const [showEdit, setShowEdit] = React.useState() //퍼블리싱임시: 체크선택시 옵션기능보여줌 06.23

  const [contAllCheck, setContAllCheck] = useState(false)
  const [isShowPdf, setIsShowPdf] = useState(false) //삭제 버튼 표시 여부
  const [showResponse, setShowResponse] = useState()
  const [showFileNm, setShowFileNm] = useState()
  const [blobResponse, setBlobResponse] = useState()
  const [docid, setDocid] = useState()
  const [crtCd, setCrtCd] = useState()
  const [brno, setBrno] = useState()
  const [oldYn, setOldYn] = useState()
  const [fileId, setFileId] = useState()
  const [printYn, setPrintYn] = useState()
  const [active, setActive] = useState()

  const tabIdRef = useRef()
  useEffect(() => {
    if (props.tabId !== tabIdRef.current) {
      tabIdRef.current = props.tabId
      setCheckedContacts(new Set())
      checkedContactsRef.current.clear()
      setContAllCheck(false)
      setShowEdit(false)
    }
  }, [props.tabId])

  useEffect(() => {
    let checkedItem = document.querySelector('input[name="row-popover"]:checked')

    if (checkedItem) checkedItem.checked = false

    // setIsOpen(false);
    // setOpenItem('');
  }, [props.data])

  //문서 구분코드
  useEffect(() => {
    if (!props.commoncode) return
  }, [props.commoncode])

  //제출처 공통코드
  // useEffect(() => {
  //   if (!props.sumitCd) return;
  //   setCodeList(props.sumitCd);
  // }, [props.sumitCd])

  useEffect(() => {
    let checkedItem = document.querySelector('input[name="row-popover"]:checked')

    if (checkedItem) checkedItem.checked = false

    // setIsOpen(false);
    // setOpenItem('');
  }, [props.data])

  useEffect(() => {
    if (props.isSubmit === true && props.isFailure === false) {
      props.success({
        title: '회수성공',
        message: '회수되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.location.reload()
          },
        },
      })
    }
  }, [props.isSubmit])

  useEffect(() => {
    if (props.isDelete === true) {
      props.success({
        title: '삭제성공',
        message: '삭제되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.location.reload()
          },
        },
      })
    }
  }, [props.isDelete])

  useEffect(() => {
    const fileList = props.sentInfo?.fileList

    if (!fileList) {
      //props.error({message: 'PDF 파일이 존재하지 않습니다.'});
      return
    }

    //commons.openPdf(fileList[0].fileId);
  }, [props.sentInfo])

  /**
   * @returns 체크한 건의 총 건수, 제출 건수, 기타 건수
   */
  const checkedSummary = () => {
    let cntSubmit = 0
    let cntOthes = 0
    checkedContactsRef.current.forEach((val) => {
      if (val.sts === '10') {
        ++cntSubmit
      } else {
        ++cntOthes
      }
    })
    return {
      cntTot: cntSubmit + cntOthes,
      cntSubmit: cntSubmit,
      cntOthes: cntOthes,
    }
  }

  const makeStatusBtn = (status) => {
    switch (status) {
      case '10':
        return <span className="text-blue">제출</span>
        break
      case '11':
        return <span className="text-red">반려</span>
        break
      case '12':
        return <span className="text-blue">수취완료</span>
        break
      case '13':
        return <span className="text-gray">회수</span>
        break
      default:
        return <></>
    }
  }

  const getCecheckedCrtRcvSeqs = () => {
    let arr = []
    checkedContactsRef.current.forEach((val) => {
      arr.push(val.crtRcvSeq)
    })
    return arr
  }
  const getCecheckedCrtSeqs = () => {
    let arr = []
    checkedContactsRef.current.forEach((val) => {
      arr.push(val.crtSeq)
    })
    return arr
  }

  // 조건 단건 변경시
  const onSelected = (e, type, value) => {
    let changedObj = {
      type: type,
      value: value,
    }

    props.changeSearchInfo(changedObj)
  }

  const onCollection = () => {
    props.confirm({
      title: '확인',
      message: '증명서를 회수하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          const params = {
            crtSeqList: getCecheckedCrtRcvSeqs(),
          }
          props.onCollection(params)
        },
      },
    })
  }

  //복수 제어 함수
  const changeShowForm = () => {
    setShowEdit(checkedContactsRef.current.size)

    let summ = checkedSummary()
    setIsColBtnShow(summ.cntSubmit && !summ.cntOthes)
  }

  const handleAllCheck = (checked) => {
    setContAllCheck(checked)
    if (checked) {
      for (let obj of props.data) {
        checkedContactsRef.current.add(obj)
      }
    } else {
      checkedContactsRef.current.clear()
    }
    setCheckedContacts(checkedContactsRef.current)
    changeShowForm()
  }

  const checkedItemHandler = (id, isChecked, obj) => {
    if (isChecked) {
      checkedContactsRef.current.add(obj)
    } else {
      for (let cont of checkedContactsRef.current) {
        if (obj === cont) {
          checkedContactsRef.current.delete(cont)
        }
      }
    }
    setCheckedContacts(checkedContactsRef.current)
    changeShowForm()
  }

  const checkHandler = ({ target }, contractObj) => {
    // setChecked(!bChecked);
    // setContract(contractObj);
    // checkedItemHandler(target.id, target.checked, contractObj.crtRcvSeq, contractObj.sts);
    checkedItemHandler(target.id, target.checked, contractObj)
  }

  const onDelete = () => {
    props.confirm({
      title: '확인',
      message: '증명서를 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          const params = {
            crtRcvSeqList: getCecheckedCrtRcvSeqs(),
            crtSeqList: getCecheckedCrtSeqs(),
            type: 'send',
          }
          props.deleteInbox(params)
        },
      },
    })
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  // let onPdfDownOld = (crtCd, docid, brno, fileObj) => {
  //   let fileList = []
  //   if (fileObj) {
  //     fileList.push(fileObj)
  //   }
  //   if (!fileList || !fileList.length) {
  //     props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
  //     return
  //   }

  //   fileList.forEach((val, idx, arr) => {
  //     setTimeout(() => {
  //       if (idx === 1) {
  //         let url = process.env.REACT_APP_API_URL + '/portal/file/general/' + fileList[idx].encryptedId
  //         let xhr = new XMLHttpRequest()
  //         xhr.responseType = 'blob'
  //         xhr.onload = function () {
  //           setShowResponse(window.URL.createObjectURL(xhr.response))
  //           setBlobResponse(xhr.response)
  //           setShowFileNm(val['originFileNm'])
  //           setIsShowPdf(true)
  //           setDocid(docid)
  //           setCrtCd(crtCd)
  //           setBrno(brno)
  //           setOldYn('Y')
  //           setFileId(fileList[idx].fileId)
  //           setPrintYn('N')
  //         }
  //         xhr.open('GET', url)
  //         xhr.send()
  //       }
  //     }, 20)
  //   })
  // }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    fileList.forEach((val, idx, arr) => {
      if (crtCd === '03' && fileList[idx].readYn === 'N') {
        const params = {
          docId: docid,
          fileId: fileList[idx].fileId,
          brno: brno,
        }
        props.getDownLoad(params)
      }

      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.send()
        xhr.onload = function () {
          if (xhr.status === 200) {
            // HTTP가 잘 동작되었다는 뜻.
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setIsShowPdf(true)
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('N')
            setFileId(fileList[idx].fileId)
            setPrintYn(fileList[idx].printYn)
          } else {
            props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
            return
          }
        }
      }, 1000)
    })
  }

  const eventHandler = (e, crtSeq) => {
    e.preventDefault()
    setActive(crtSeq)
  }

  // let styleTd = {
  //   cursor: 'pointer',
  // }

  const onShowOut = (e) => {
    e.preventDefault()
    setActive('')
  }

  return (
    <>
      <Alert />
      <div className="list-header">
        {/* <span className="total-num">계약서 목록 <em>123</em></span> */}
        <span className="total-num">
          현재페이지 <em>{props.pagingInfo?.currentPage}</em>/{props.pagingInfo?.totalPage} {props.pagingInfo?.totalRecords}건
        </span>
        <span className="right">
          <a className="btn-gray sm cursor" onClick={(e) => handleAllCheck(!contAllCheck)}>
            전체선택
          </a>
          <a className="btn-gray sm cursor" onClick={() => onCollection()}>
            회수
          </a>
          <a className="btn-gray sm cursor" onClick={() => onDelete()}>
            삭제
          </a>
        </span>
      </div>

      <div className="tbl-wrap mobile-scroll">
        <table className="tbl-list">
          <caption>선택, 신청방법, 증명서 및 발급번호, 발급처, 제출처, 발급일시, 최종이력, 상태, 열람 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '5%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '8%' }} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">선택</th>
              {/*<th scope="col">신청방법</th>*/}
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'DOCID')
                  }}
                >
                  증명서 및 발급번호
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'PRCHS_NM')
                  }}
                >
                  발급처
                </a>
              </th>
              <th scope="col">시료명</th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'RCV_MEMBER')
                  }}
                >
                  제출처
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'ISSUEDT')
                  }}
                >
                  발급일시
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'MOD_DT')
                  }}
                >
                  최종이력
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'STS')
                  }}
                >
                  상태
                </a>
              </th>
              <th scope="col">열람</th>
            </tr>
          </thead>
          <tbody>
            {props.data?.length > 0 ? (
              props.data?.map((contractObj, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="checkbox"
                      title={contractObj.crtNm + ' 체크박스'}
                      id={`${'row-' + contractObj.crtRcvSeq + index}`}
                      onChange={(e) => checkHandler(e, contractObj)}
                      checked={checkedContactsRef.current.has(contractObj)}
                    />
                    <em></em>
                  </td>
                  {/*<td onClick={() => props.onSentDetail(contractObj)} className="cursor">*/}
                  {/*  {contractObj.docType}*/}
                  {/*</td>*/}
                  <td onClick={() => props.onSentDetail(contractObj)} className="cursor">
                    {contractObj.crtNm}
                    <span className="txt1">{contractObj.docid}</span>
                  </td>
                  <td onClick={() => props.onSentDetail(contractObj)} className="cursor">
                    {contractObj.prchsNm}
                  </td>
                  <td onClick={() => props.onSentDetail(contractObj)} className="cursor">{/* 시료명 */}
                    {JSON.parse(contractObj?.gnrlInfoCn)?.splore_nm}
                  </td>
                  <td onClick={() => props.onSentDetail(contractObj)} className="cursor">
                    {contractObj.rcvMember}
                  </td>
                  <td onClick={() => props.onSentDetail(contractObj)} className="cursor">
                    {contractObj.issuedt === null ||
                    moment(contractObj?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss') === 'Invalid date'
                      ? '-'
                      : moment(contractObj?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
                  </td>
                  <td onClick={() => props.onSentDetail(contractObj)} className="cursor">
                    {contractObj.modDt === null || moment(contractObj.modDt).format('YYYY.MM.DD HH:mm:ss') === 'Invalid date'
                      ? '-'
                      : moment(contractObj.modDt).format('YYYY.MM.DD HH:mm:ss')}
                  </td>
                  <td onClick={() => props.onSentDetail(contractObj)} className="cursor">
                    {makeStatusBtn(contractObj?.sts)}
                  </td>
                  <td>
                    {contractObj.fileGroupId !== null && contractObj.fileNewList?.length !== 0 && contractObj.fileNewList?.length === 1 && (
                      <div className="attach-wrap">
                        {contractObj.fileNewList?.map((fileObj, index) => (
                          <a
                            key={index}
                            className="attach attach-link"
                            onClick={(e) => {
                              e.preventDefault()
                              onPdfDown(contractObj.crtCd, contractObj.docid, contractObj.brno, fileObj)
                              return
                            }}
                          >
                            첨부
                          </a>
                        ))}
                      </div>
                    )}
                    {contractObj.fileGroupId !== null && contractObj.fileNewList?.length !== 0 && contractObj.fileNewList?.length !== 1 && (
                      <div className="attach-wrap">
                        <a
                          href="#"
                          className="attach attach-link"
                          onClick={(e) => eventHandler(e, contractObj.crtSeq + index)}
                          aria-expanded={active === contractObj.crtSeq + index ? 'true' : 'false'}
                          aria-controls={contractObj.crtSeq + index}
                          aria-disabled={active === contractObj.crtSeq + index ? 'true' : 'false'}
                        >
                          첨부
                        </a>
                        <ul
                          id={contractObj.crtSeq + index}
                          className={active === contractObj.crtSeq + index ? 'attach-file active' : 'attach-file'}
                        >
                          {contractObj.fileNewList?.map((fileObj, index) => (
                            <li key={index}>
                              <a
                                onClick={(e) => {
                                  e.preventDefault()
                                  onPdfDown(contractObj.crtCd, contractObj.docid, contractObj.brno, fileObj)
                            	  onShowOut(e)
                                  return
                                }}
                              >
                                {fileObj.originFileNm}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {contractObj.fileGroupId === null && '-'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="center" colSpan={9}>
                  <div className="nodata">조회 결과가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isShowPdf === true && (
        <PdfViewer
          blobResponse={blobResponse}
          showResponse={showResponse}
          fileNm={showFileNm}
          crtCd={crtCd}
          docid={docid}
          brno={brno}
          oldYn={oldYn}
          fileId={fileId}
          printYn={printYn}
          onClose={() => setIsShowPdf(false)}
        />
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    sentInfo: state.sent?.sentInfo,
    sumitCd: state.commoncode?.co?.CRT_SUBMIS_TP,
    isSubmit: state.sent.isSubmit,
    isFailure: state.sent.isFailure,
    isDelete: state.inbox?.isDelete,
  }
}

const actionCreators = {
  getSentInfo: sentActions.getSentInfo,
  changeSearchInfo: sentActions.changeSearchInfo,
  deleteInbox: inboxActions.deleteInboxList,
  success: alertActions.success,
  readSentList: sentActions.readSentList,
  getCommonCode: commonActions.getCommonCode,
  onCollection: sentActions.onCollection,
  confirm: alertActions.confirm,

  getDownLoad: certboxActions.getDownLoad,
}

export default connect(mapStateToProps, actionCreators)(CertificateSentList)
